// extracted by mini-css-extract-plugin
module.exports = {"uiboarddetails":"uiboarddetails_uiboarddetails__AVvz7"};